import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=3e963675&scoped=true&"
import script from "./UserNav.vue?vue&type=script&lang=js&"
export * from "./UserNav.vue?vue&type=script&lang=js&"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=3e963675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e963675",
  null
  
)

export default component.exports